export default __webpack_public_path__ + "static/12-cdacceced0d7f7b48ae57adfbe38c0ba.webp";